import React from 'react'
import { Header, Card, Icon, Label, Accordion, Image, Container } from 'semantic-ui-react';
import _ from 'lodash'
import LibraryCard from './LibraryCard'
import noPlaybookImage from '../../../../../images/grafix-banner/lifecycledesigner.svg';


var moment = require('moment');
class GroupedLibraryCard extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    // In Design = 0,  In-Review  = 1,  Approved = 2,  Rejected=3, Published=4, Deprecated=5, Clone / Purchased = 6, Generating = -1 
    switchStatus = (number) => {
        switch (number) {
            case "-1":
                return "Generating"
            case "0":
                return "In Design"
            case "1":
                return "Review request"
            case "2":
                return "Approved"
            case "3":
                return "Rejected"
            case "4":
                return "Published"
            case "5":
                return "Inactive"
            case 6:
                return "Clone / Purchased"
            default:
                return number
        }
    }

    switchScope = (scope) => {
        switch (scope) {

            case "Private":
                return "Workspace Library"
            case "Public":
                return "Public Library"
            default:
                return scope
        }
    }

    render() {
        const { PracticeLibrarys, sortingFlag } = this.props;
        var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base'
        });

        const sortByTagNames = function (ascending) {

            return function (a, b) {

                // equal items sort equally
                if (a.heading.toUpperCase() === b.heading.toUpperCase()) {
                    return 0;
                }
                // "No TAG" sort after anything else
                if (a.heading === "No TAG") {
                    return 1;
                }
                else if (b.heading === "No TAG") {
                    return -1;
                }
                // otherwise, if we're ascending, lowest sorts first
                if (ascending) {
                    return a.heading.toUpperCase() < b.heading.toUpperCase() ? -1 : 1;
                }
                // if descending, highest sorts first
                else {
                    return a.heading.toUpperCase() < b.heading.toUpperCase() ? 1 : -1;
                }
            };

        }

        const groupByTags = function (playbookData) {

            const tagObject = {
                "No TAG": []
            };

            playbookData && playbookData.forEach(playBookElement => {
                const tags = playBookElement.tags;
                if (tags && tags.length > 0) {
                    tags.forEach(tagValue => {
                        if (!tagObject[tagValue]) {
                            tagObject[tagValue] = [];
                        }
                        tagObject[tagValue].push(playBookElement);
                    })
                } else {
                    tagObject["No TAG"].push(playBookElement);
                }
            });

            const returnObject = [];

            const keys = Object.keys(tagObject);

            keys.forEach(key => {
                const obj = {
                    heading: key,
                    playbooks: tagObject[key]
                }
                returnObject.push(obj);
            });
            return returnObject;
        }

        let pl = PracticeLibrarys && PracticeLibrarys.length !== 0 ?
            PracticeLibrarys.sort((a, b) => {
                return collator.compare(a.name, b.name)
            }) : null
        let gropuBy;

        if (sortingFlag.key === 'name') {
            gropuBy = _(pl)
                .groupBy(o => o.name[0].toUpperCase())
        } else if (sortingFlag.key === 'scope') {
            gropuBy = _(pl)
                .sortBy(v => -new Date(v.createdAt))
                .groupBy(o => o.scope)
        } else if (sortingFlag.key === 'baseCategory') {
            gropuBy = _(pl)
                .groupBy(o => o.baseCategory._id)
        } else if (sortingFlag.key === 'category') {
            gropuBy = _(pl)
                .groupBy(o => o.category._id)
        } else if (sortingFlag.key === 'subCategory') {
            gropuBy = _(pl)
                .sortBy(v => -new Date(v.createdAt))
                .groupBy(o => o.subCategory._id)
        } else if (sortingFlag.key === 'status') {
            gropuBy = _(pl)
                .groupBy(o => o.status)
        } else if (sortingFlag.key === 'tags') {
            gropuBy = groupByTags(pl);
        } else if (sortingFlag.key === 'createdAt') {
            gropuBy = _(pl)
                .sortBy(v => -new Date(v.createdAt))
                .groupBy(v => new Date(v.createdAt).getFullYear()+" - "+new Date(v.createdAt).getMonth())
        } else if (sortingFlag.key === 'updatedAt') {
            gropuBy = _(pl)
                .sortBy(v => moment(v.updatedAt).format('YYYYMMMM'))
                .groupBy(v => moment(v.updatedAt).format('YYYY MMMM'))
        } else if (sortingFlag.key === 'favourite') {
            gropuBy = _.chain(pl)
                .filter(f => f.favourite)
                .groupBy(o => o.favourite)
        } else {
            gropuBy = _(pl)
                .groupBy(o => o.name[0].toUpperCase())
        }


        function sortByHeading(a, b) {

            let hA = a.heading.toUpperCase();
            let hB = b.heading.toUpperCase();
            let sA = a.sortBy && a.sortBy.toUpperCase();
            let sB = b.sortBy && b.sortBy.toUpperCase();

            if (sA < sB) {
                return -1;
            }
            else if (sA > sB) {
                return 1;
            }
            else {
                if (hA < hB) {
                    return -1;
                }
                else if (hA > hB) {
                    return 1;
                }
                return 0;
            }
        }

        let value = null;
        let groupedData = null
        if (sortingFlag.key === 'tags') {
            value = gropuBy;
            const compareFunction = sortingFlag.order === -1 ? sortByTagNames(true) : sortByTagNames(false)
            groupedData = value.sort(compareFunction);
        } else if (sortingFlag.key === 'subCategory') {
            value = gropuBy
                .map((playbooks, heading) => ({ heading: heading, playbooks: playbooks, sortBy: playbooks[0].baseCategory.name, lastestCreatedAt: Math.max(...playbooks.map(pb => new Date(pb.createdAt).getTime()))  }))
                .value();
            //groupedData = sortingFlag.order === -1 ? value.sort(sortByHeading) : value.sort(sortByHeading).reverse();
            groupedData = value.sort((a, b) => b.latestCreatedAt - a.latestCreatedAt);
        } else if(sortingFlag.key === 'createdAt'){
            let months= ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            value = gropuBy
                .map((playbooks, heading) => ({ heading, playbooks }))
                .value();
            groupedData = sortingFlag.order === -1 ? value.sort(sortByHeading) : value.sort(sortByHeading).reverse();
            groupedData.map(a=>{
                a.heading = a.heading.slice(0,4) + " " + months[a.heading.slice(7)]
            })
        }else {
            value = gropuBy
                .map((playbooks, heading) => ({ heading, playbooks }))
                .value();
            groupedData = sortingFlag.order === -1 ? value.sort(sortByHeading) : value.sort(sortByHeading).reverse();
        }

        let panels = []
        for (let i = 0; i < groupedData.length; i++) {
            panels.push({
                key: i,
                title: {
                    content: (
                        <span>
                            {sortingFlag.key === 'status' ?
                                this.switchStatus(groupedData[i].heading) :
                                sortingFlag.key === 'scope' ?
                                    this.switchScope(groupedData[i].heading) :

                                    sortingFlag.key === 'subCategory' ?
                                        groupedData[i].playbooks[0].baseCategory.name !== "" ?
                                            <span>
                                                {groupedData[i].playbooks[0].baseCategory.name} <Icon name="chevron right" />
                                                {groupedData[i].playbooks[0].category.name} <Icon name="chevron right" />
                                                {groupedData[i].playbooks[0].subCategory.name}
                                            </span> :
                                            <span>No Categories </span> :
                                        groupedData[i].heading.length === 0 ? "Others" :
                                            groupedData[i].heading === "true" ?
                                                sortingFlag.key : groupedData[i].heading} &nbsp;&nbsp;
                            <Label size="mini" >
                                {groupedData[i].playbooks.length}
                            </Label>
                        </span>
                    ),
                },
                content: {
                    content: <span>
                        <Card.Group className="playbookCardsList" >
                            {groupedData[i].playbooks && groupedData[i].playbooks.map((PracticeLibrary, index) => {
                                
                                return   <LibraryCard
                                    id={PracticeLibrary._id}
                                    key={index}
                                    index={index}
                                    PracticeLibrary={PracticeLibrary}
                                    clickIndex={this.props.libraryCardIndex}
                                    selectedPracticeLibrary={this.props.selectedPracticeLibrary}
                                    selectedCardLoader={this.props.selectedCardLoader} />
                            })}
                        </Card.Group>
                    </span>
                }
            })
        }

        return (
            //*************For accordian View*************
            <div>
                <Accordion
                    defaultActiveIndex={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                    panels={panels}
                    exclusive={false}
                    fluid
                    className="groupingCards"
                />
                {groupedData && groupedData.length === 0 ?
                    <Container fluid className="pad_40">
                        <Image src={noPlaybookImage} className="landingImage" size='large' centered={true} style={{ width: "300px" }} />
                        <Header as='h3' icon textAlign='center'>
                            <Header.Content >
                                No Playbook to display
                                <br /> <br /> <br />
                            </Header.Content>

                        </Header>
                    </Container> : null}

            </div>
        )
    }
}

export default GroupedLibraryCard;